<template>
<div class="content-wrap py-0">

    <div id="section-home" class="page-section bg-contrast-100 mb-3">

        <div class="container text-center">

            <h2 class="mx-auto mb-2 font-body" style="max-width: 700px; font-size: 40px;"> Welcome to <span>MYSCH</span></h2>

            <p class="lead mx-auto mb-3" style="max-width: 800px;">Your Awesome School Manager. Manage your School, Student Results, Testimonials, Certificates, Attendance, Learning etc all in One Place </p>

            <div class="col-lg-12">
                <a :href="$router.resolve({ name: 'Register' }).href" data-lightbox="inline" class="button ls-1 text-uppercase fw-bold button-large button-rounded button-shadow">Sign Up Now</a>
                <a :href="$router.resolve({ name: 'Login' }).href" class="button ls-1 text-uppercase fw-bold button-large button-rounded button-border">Login</a>
            </div>

        </div>
    </div>
    
    <div class="container">

        <div class="row col-mb-50 mb-2 pt-2">
            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn">
                        <a href="#"><i class="fa fa-info-circle"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Custom School Website</h3>
                        <p>Create, Publish and Maintain your School Website</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="100">
                        <a href="#"><i class="fa fa-calendar-alt"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Session Management</h3>
                        <p>Manage Current Term, Past Terms and New Sessions. Set School resumption dates.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="200">
                        <a href="#"><i class="fa fa-chalkboard"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Class Management</h3>
                        <p>Manage Classes, Add / Update / Remove Classes in your school.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="400">
                        <a href="#"><i class="fa fa-book"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Subject Management</h3>
                        <p>Add/Update/Remove Subjects and assign them to school arms.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn">
                        <a href="#"><i class="fa fa-user-graduate"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Student Management</h3>
                        <p>Add, remove students in classes. Promote students to new classes. Manage inactive students.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="200">
                        <a href="#"><i class="fa fa-pencil-alt"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Scores Management</h3>
                        <p>Enter/Update Subject Scores, Remarks + Attendance, & Affective + Cognitive + Psychomotors.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="400">
                        <a href="#"><i class="fa fa-print"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Result Sheet Printing</h3>
                        <p>View and Print student report sheets, and broadsheets for teachers.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="600">
                        <a href="#"><i class="fa fa-file-alt"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Lesson Notes / Plans</h3>
                        <p>Generate Lesson Notes and Plans in Seconds manually &amp; with AI.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="800">
                        <a href="#"><i class="fa fa-id-card"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>FlashCards Learning</h3>
                        <p>Generate beautiful flashcards to manage your pupils learning processes.</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="1000">
                        <a href="#"><i class="fa fa-calendar-check"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Attendance System</h3>
                        <p>Track attendance records for your students and teachers</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
                <div class="feature-box fbox-plain">
                    <div class="fbox-icon bounceIn animated" data-animate="bounceIn" data-delay="400">
                        <a href="#"><i class="fa fa-piggy-bank"></i></a>
                    </div>
                    <div class="fbox-content">
                        <h3>Accounting System</h3>
                        <p>Manage School Fees, Salaries and other dues</p>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="section mt-0">
        <div class="container">

            <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="feature-box fbox-outline fbox-dark fbox-effect">
                    <div class="fbox-icon">
                        <a href="#"><i class="fa fa-school"></i></a>
                    </div>
                    <div class="fbox-content">
                        <div class="counter counter-small">
                            <span data-from="0" data-to="300" data-refresh-interval="50" data-speed="1000">300</span>+
                        </div>
                        <h5 class="m-0 color">Schools Registered</h5>
                        <div class="d-block d-md-block d-lg-none mb-5"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="feature-box fbox-outline fbox-dark fbox-effect">
                    <div class="fbox-icon">
                        <a href="#"><i class="fa fa-user-graduate"></i></a>
                    </div>
                    <div class="fbox-content">
                        <div class="counter counter-small">
                            <span data-from="100" data-to="4000" data-refresh-interval="250" data-speed="2000">40000</span>+
                        </div>
                        <h5 class="m-0 color">Students Profile</h5>
                        <div class="d-block d-md-block d-lg-none mb-5"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="feature-box fbox-outline fbox-dark fbox-effect">
                    <div class="fbox-icon">
                        <a href="#"><i class="fa fa-print"></i></a>
                    </div>
                    <div class="fbox-content">
                        <div class="counter counter-small">
                            <span data-from="100" data-to="3500" data-refresh-interval="500" data-speed="3000">350000</span>+
                        </div>
                        <h5 class="m-0 color">Results Printed</h5>
                        <div class="d-block d-md-none mb-5"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="feature-box fbox-outline fbox-dark fbox-effect">
                    <div class="fbox-icon">
                        <a href="#"><i class="fa fa-chalkboard-teacher"></i></a>
                    </div>
                    <div class="fbox-content">
                        <div class="counter counter-small">
                            <span data-from="100" data-to="250" data-refresh-interval="40" data-speed="3500">250</span>+
                        </div>
                        <h5 class="m-0 color">Class Plans</h5>
                    </div>
                </div>
            </div>
        </div>


        </div>
    </div>

    <div class="section mt-0 mb-0">
        <div class="container">
            <div class="row align-items-center justify-content-between">
                <div class="col-lg-6">
                    <div class="heading-block border-bottom-0 mb-0">
                        <small class="text-black-50 text-uppercase ls-3 fw-semibold">Get Started</small>
                        <h2 class="text-capitalize fw-semibold mb-2" style="font-size: 44px; letter-spacing: -1px">Next Steps!</h2>
                        <p class="lead">Join our growing community of schools using MYSCH Web Software</p>
                    </div>
                </div>

                <div class="col-lg-6 d-inline-block d-sm-inline-flex justify-content-start justify-content-lg-end">
                    <a :href="$router.resolve({ name: 'Register' }).href" data-lightbox="inline" class="button ls-1 text-uppercase fw-bold button-large button-rounded button-shadow">Sign Up Now</a>
                    <a :href="$router.resolve({ name: 'Login' }).href" class="button ls-1 text-uppercase fw-bold button-large button-rounded button-border">Login</a>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
export default {
    
}
</script>